import { Table } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import Notifier from "../../components/Notifier";
import Api from "../../utils/Api";
import remove_button from "../../resources/remove.png";

export default function RecurringTransactions({ isMobile }) {
    const [items, setItems] = useState([]);
    const notifierRef = React.createRef();

    const cardStyle = {
        background: "white",
        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        borderRadius: "10px",
        width: isMobile ? "95%" : "50%",
        margin: "auto",
        marginTop: isMobile ? "0px" : "10px",
    };

    const cellStyle = {
        padding: isMobile ? "6px 8px" : "8px 12px",
        overflowWrap: "anywhere"
    };
    const narrowCellStyle = { padding: "6px 4px", whiteSpace: "nowrap" };

    useEffect(() => {
        refreshData();
    }, []);

    const refreshData = async () => {
        try {
            const { response } = await Api.getRecurringTransactions();
            setItems(response || []);
        } catch (e) {
            console.error("Failed to load recurring transactions", e);
        }
    };

    const deleteItem = async (description) => {
        try {
            const response = await Api.deleteRecurringTransaction({ description });
            if (response.status === 200) {
                refreshData();
                notifierRef?.current?.showSuccess("נמחק בהצלחה");
            } else {
                notifierRef?.current?.showError("שגיאה במחיקה");
            }
        } catch (e) {
            console.error("Failed to delete recurring transaction", e);
            notifierRef?.current?.showError("שגיאה במחיקה");
        }
    };

    return (
        <div>
            <div style={cardStyle}>
                {/* Fixed layout: תיאור and שם share the free space evenly and wrap as needed,
                    while סוג and מחק stay narrow so the trash icon is always on screen. */}
                <Table dir="RTL" style={{ width: isMobile ? "100%" : "90%", margin: "auto", tableLayout: "fixed" }}>
                    <thead>
                        <tr>
                            <th style={cellStyle}>תיאור</th>
                            <th style={cellStyle}>שם</th>
                            <th style={{ ...narrowCellStyle, width: "60px" }}>סוג</th>
                            <th style={{ ...narrowCellStyle, width: "45px" }}>מחק</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item) => (
                            <tr key={item.id}>
                                <td style={cellStyle}>{item.description}</td>
                                <td style={cellStyle}>{item.name}</td>
                                <td style={narrowCellStyle}>{item.type === "CREDITCARD" ? "אשראי" : "בנק"}</td>
                                <td style={narrowCellStyle}>
                                    <div onClick={() => deleteItem(item.description)} style={{ paddingTop: "10%", cursor: "pointer" }}>
                                        <img src={remove_button} style={{ width: "20px", height: "20px" }} alt="מחק" />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                {items.length === 0 && (
                    <div style={{ textAlign: "center", padding: "20px", color: "#999" }}>
                        אין פעולות חוזרות
                    </div>
                )}
                <Notifier ref={notifierRef} />
            </div>
        </div>
    );
}
